import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import AddCompanyForm from '../forms/AddCompanyForm';

const useStyles = makeStyles((theme) => ({
  submitButton: {
    margin: theme.spacing(2),
    borderRadius: 50,
    minWidth: 36,
    width: 'auto',
    padding: '6px 12px 6px 6px',
    position: 'relative',
  },
}));

export default function AddProductButton() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        className={classes.submitButton}
        onClick={handleOpen}
      >
        <AddIcon />
        Add Company
      </Button>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Add Company</DialogTitle>
        <DialogContent>
          <DialogContentText>
            To add a company, please fill the following fields:
          </DialogContentText>
          <AddCompanyForm callback={handleClose} />
        </DialogContent>
      </Dialog>
    </>
  );
}
